import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const UPDATE_PROMPT_SHOWN_IN_SESSION_KEY = 'pwa_update_prompt_shown_in_session';
let isUpdatePromptVisible = false;

const canShowUpdatePrompt = () => {
  try {
    return window.sessionStorage.getItem(UPDATE_PROMPT_SHOWN_IN_SESSION_KEY) !== '1';
  } catch (error) {
    return true;
  }
};

const markUpdatePromptShown = () => {
  try {
    window.sessionStorage.setItem(UPDATE_PROMPT_SHOWN_IN_SESSION_KEY, '1');
  } catch (error) {
    // Ignore sessionStorage access failures (private mode, browser restrictions).
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>   
    <App/>
  </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('✅ PWA: App is ready for offline use');
  },
  onUpdate: (registration) => {
    console.log('🔄 PWA: New version available. Please refresh to update.');

    if (!registration || !registration.waiting) {
      return;
    }

    if (isUpdatePromptVisible || !canShowUpdatePrompt()) {
      return;
    }

    isUpdatePromptVisible = true;
    markUpdatePromptShown();

    const shouldRefresh = window.confirm('New version available! Refresh to update?');

    if (shouldRefresh) {
      let hasReloaded = false;
      const reloadOnce = () => {
        if (hasReloaded) return;
        hasReloaded = true;
        window.location.reload();
      };

      if (navigator.serviceWorker) {
        navigator.serviceWorker.addEventListener('controllerchange', reloadOnce, { once: true });
      }

      registration.waiting.postMessage({ type: 'SKIP_WAITING' });

      // Fallback in case controllerchange does not fire quickly.
      window.setTimeout(reloadOnce, 1500);
    }

    isUpdatePromptVisible = false;
  }
});

// Check for updates every hour
setInterval(() => {
  serviceWorkerRegistration.checkForUpdates();
}, 60 * 60 * 1000);
